import React, { useRef } from 'react';
import ZoomImage from "./ZoomImage";
export default function ImageReel({ imagenes }) {

    // Zoom
    const zoomRef = useRef();
    const callZoom = (imagen) => {
        if (zoomRef.current) {
            zoomRef.current.openFullscreen(imagen);
        }
    };
    // ----

    return (
        <div>
            <div className="image-reel">
                {imagenes.map((imagen, index) => {
                    return (
                        <div key={index} className="image-container" onClick={() => callZoom(imagen)}>
                            <img className="image-normal" src={imagen} alt="" loading="lazy" />
                        </div>
                    );
                })}

            </div>
            <ZoomImage ref={zoomRef} />
        </div>
    );
}